export default "__VITE_ASSET__WPr13S52__"